<template>
  <div :class="this.class">
    <span class="owal panel header content container">
      <span v-if="this.title">
        {{ this.title }}
      </span>
      <slot v-else/>
      <span v-if="this.buttons" class="owal panel header buttons container">
        <owal-panel-header-button
          v-for="button in buttons"
          :key="button.identifier"
          :identifier="button.identifier"
          :title="button.title"
          @button-click="handleButtonClick(button.identifier)"
          />
      </span>
    </span>
  </div>
</template>

<script>
import OwalPanelHeaderButton from './OwalPanelHeaderButton'
export default {
  name: 'OwalPanelHeader',
  components: { OwalPanelHeaderButton },
  props: {
    title: {
      type: String,
      default: undefined,
    },
    /* deprecated, use position instead. */
    topAttached: {
      type: Boolean,
      default: false,
      validation (value) {
        console.warn(`(OwalPanelHeader) : topAttached is deprecated. Use position instead.`)
        return true
      },
    },
    position: {
      type: String,
      default: 'top',
      validation: function (value) {
        const validValues = ['top', 'middle', 'bottom']
        if (!validValues.includes(value)) {
          console.warn(`(OwalPanelHeader) : Invalid value passed to the position prop. Use one of: 'top' 'middle' or 'bottom'. (The default is 'top'. You passed: '${value}').`)
          return false
        }
        return true
      },
    },
    buttons: {
      type: Array,
      default: undefined,
    },
  },
  computed: {
    class () {
      const cssClass = `owal panel ${this.position} header`
      return cssClass
    },
  },
  methods: {
    handleButtonClick: function (identifier) {
      this.$emit('button-click', identifier)
    },
  },
}
</script>

<style scoped>

.owal.panel.top.header,
.owal.panel.middle.header,
.owal.panel.bottom.header {
  display: block;
  border: none;
  height: 2.75rem;
  box-sizing: border-box;
  font-size: 18px;
  padding: 0.685rem 0.685rem 0.685rem 2.19rem;
  background: #EFF2F7;
  font-family: Lato-Black, Avenir-Black, sans-serif;
}

.owal.panel.header.content.container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
}

.owal.panel.top.header {
  border-width: 0;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  border-bottom: 1px solid #979797;

}

.owal.panel.middle.header {
  border-top: 1px solid #979797;
  border-bottom: 1px solid #979797;
}

.owal.panel.bottom.header {
  border-width: 0;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  border-top: 1px solid #979797;
  justify-content: flex-end;

}

.owal.panel.header.buttons.container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  height: 2.1rem;
  margin-right: 2.19rem;
  margin-left: 0.685rem;
  flex-grow: 20;
}
</style>
